import type { SetupStatus } from '../../../types'
import { API_BASE } from '../constants'
import type { Translator } from './types'
import { sanitizeSetupErrorMessage } from './errors'
import { readResponsePayload, toResponseError, toSetupStatus } from './payloads'
import { requestSetupApi } from './request'

export const requestSetupStatus = async ({ t }: { t: Translator }): Promise<SetupStatus> => {
  const response = await requestSetupApi({
    path: '/setup/status',
    fallbackError: t('setup.toast.statusLoadError'),
    init: {
      credentials: 'include',
    },
  })
  const { raw, data } = await readResponsePayload(response)

  if (!response.ok) {
    const message = toResponseError({
      raw,
      data,
      fallback: t('setup.toast.statusError', { status: response.status }),
    })
    throw new Error(sanitizeSetupErrorMessage({ message, t }))
  }

  return toSetupStatus({
    data,
    defaults: {
      firstInstallCompleted: false,
      adminCount: 0,
      hasSuperAdmin: false,
      hasSiteManager: false,
    },
  })
}
